import { useEffect, useState, useCallback } from 'react'
import { DollarSign, ArrowDownRight, ArrowUpRight, Filter } from 'lucide-react'
import api from '../api/client'
import Pagination from '../components/Pagination'

const money = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
const dt = (s) => (s ? new Date(s).toLocaleDateString('pt-BR') : '—')
const CATS = [
  ['', 'Todos'], ['produtos', 'Produtos'], ['servicos', 'Serviços'], ['expansao', 'Expansão'],
  ['bonificacoes', 'Bonificações'], ['recorrentes', 'Comissões recorrentes'], ['transferencia', 'Transferências'],
]

function Card({ label, value, accent }) {
  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
      <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
      <p className={`font-heading text-2xl font-bold ${accent || 'text-gray-900'}`}>{value}</p>
    </div>
  )
}

export default function Comissoes() {
  const [resumo, setResumo] = useState({})
  const [rows, setRows] = useState([])
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(20)
  const [meta, setMeta] = useState({ total: 0, pages: 1 })
  const [cat, setCat] = useState('')

  const load = useCallback((p = 1, sz = size, c = cat) => {
    const qs = `page=${p}&limit=${sz}${c ? '&categoria=' + c : ''}`
    api.get(`/financeiro/extrato?${qs}`).then((r) => {
      setRows(r.data.data || [])
      setMeta({ total: r.data.total || 0, pages: r.data.pages || 1 })
      setPage(p)
    }).catch(() => setRows([]))
  }, [size, cat])

  useEffect(() => {
    api.get('/financeiro/resumo').then((r) => setResumo(r.data)).catch(() => {})
  }, [])
  useEffect(() => { load(1) }, [load])

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow"><DollarSign size={20} className="text-white" /></div>
        <div>
          <h1 className="text-2xl font-heading font-bold text-gray-900">Meus Ganhos</h1>
          <p className="text-sm text-gray-500">Extrato detalhado de movimentações — comissões, bônus, transferências e compras com saldo.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card label="Prévia de Ganhos" value={money(resumo.previa)} accent="text-amber-600" />
        <Card label="Disponível p/ Saque" value={money(resumo.saldo_disponivel)} accent="text-emerald-600" />
        <Card label="Total de Ganhos" value={money(resumo.total_geral)} accent="text-indigo-700" />
      </div>

      <div className="bg-white rounded-2xl p-3 shadow-sm border border-gray-100 flex items-center gap-1.5 flex-wrap">
        <Filter size={15} className="text-gray-400" />
        {CATS.map(([k, label]) => (
          <button key={k || 'todos'} onClick={() => { setCat(k); load(1, size, k) }} className={`px-3 py-1.5 rounded-lg text-xs font-semibold ${cat === k ? 'bg-gray-900 text-white' : 'bg-gray-50 border border-gray-200 text-gray-600'}`}>{label}</button>
        ))}
      </div>

      <div>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
          <table className="w-full text-sm whitespace-nowrap">
            <thead className="bg-gray-50 text-gray-500 text-left text-xs uppercase tracking-wider">
              <tr><th className="px-4 py-2">Data</th><th className="px-4 py-2">Tipo</th><th className="px-4 py-2">Evento</th>
                <th className="px-4 py-2">Referência / Origem</th><th className="px-4 py-2">Nível</th><th className="px-4 py-2 text-right">PV</th>
                <th className="px-4 py-2">Status</th><th className="px-4 py-2 text-right">Valor</th></tr>
            </thead>
            <tbody>
              {rows.map((c) => {
                const neg = Number(c.valor) < 0
                return (
                  <tr key={c.id} className="border-t border-gray-100 hover:bg-primary-50/30">
                    <td className="px-4 py-2 text-gray-500 text-xs">{dt(c.data)}</td>
                    <td className="px-4 py-2">{c.tipo}</td>
                    <td className="px-4 py-2 text-gray-600">{c.evento}</td>
                    <td className="px-4 py-2 text-gray-600">{c.referencia || c.cliente || c.produto || '—'}</td>
                    <td className="px-4 py-2 text-gray-400">{c.nivel}</td>
                    <td className="px-4 py-2 text-right text-gray-500">{c.pv ? c.pv : '—'}</td>
                    <td className="px-4 py-2"><span className="text-[11px] text-gray-500">{c.status || '—'}</span></td>
                    <td className={`px-4 py-2 text-right font-semibold ${neg ? 'text-red-600' : 'text-emerald-600'}`}>
                      <span className="inline-flex items-center gap-1 justify-end">{neg ? <ArrowDownRight size={13} /> : <ArrowUpRight size={13} />}{money(Math.abs(c.valor))}</span>
                    </td>
                  </tr>
                )
              })}
              {rows.length === 0 && <tr><td colSpan="8" className="px-4 py-8 text-center text-gray-400">Sem movimentações nesta categoria.</td></tr>}
            </tbody>
          </table>
        </div>
        <Pagination page={page} pages={meta.pages} total={meta.total} pageSize={size} onPage={(p) => load(p)} onPageSize={(n) => { setSize(n); load(1, n) }} />
      </div>
    </div>
  )
}
